export default "__VITE_ASSET__oPaNoj_e__"